export var loadingReducer = (state = [], action) => {
	var newState = null;

	switch(action.type) {
		case "SET_LOADING": 
			newState = [...state, "Loading"];
			return newState;
		case "SET_SAVING": 
			newState = [...state, "Saving"];
			return newState;
		case "SET_SEARCHING":
			newState = [...state, "Searching"];
			return newState;
		case "SET_SENDING":
			newState = [...state, "Sending"];
			return newState;
		case "SET_DELETING":
			newState = [...state, "Deleting"];
			return newState;
		case "SET_UPLOADING":
			newState = [...state];
			var lastState = newState.length > 0 ? newState[newState.length-1] : "";
			var txt = "Uploading";
			if (lastState.indexOf(""))
				newState.pop();

			if (action.total !== undefined && action.total !== null) {
				if (action.index !== undefined && action.index !== null) {
					txt += " " + action.index + " of " + action.total;
				}
			}
		
			newState.push(txt);
			return newState;
		case "POP_LOADING":
			newState = [...state];
			newState.pop();
			return newState;
		case "RESET_LOADING":
			return [];
		default:
			return state;
	}
}


// WEBPACK FOOTER //
// ./src/reducers/loadingReducer.js